'use strict';

var _ = require('lodash');

/**
 * Flight Analysis - Chart (metric: Loadfactor, Revenue)
 */
var FlightCabinTransformerFactory = function FlightCabinTransformerFactory($filter, DataTransformer, momentService, dtdFilteringService, metricReferenceDataService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function FlightCabinTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['cabin', 'cabin-da', 'cabin-post-departure', 'cabin-deep'];
    this.priority = 0;
  }
  FlightCabinTransformer.prototype = Object.create(DataTransformer.prototype);
  FlightCabinTransformer.constructor = FlightCabinTransformer;
  FlightCabinTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType.indexOf(sourceType) > -1;
  };
  FlightCabinTransformer.prototype.isCacheable = function () {
    return true;
  };
  FlightCabinTransformer.prototype.getCacheKey = function (metrics, metricDescriptor) {
    return this.sourceType.join('-') + '-' + metrics.join('-') + _.get(metricDescriptor, 'params.selectedReference');
  };
  function getMetricsKeys(metrics) {
    var metricsKeys = [];
    for (var m = 0; m < metrics.length; m++) {
      metricsKeys[m] = 'm' + (m + 1);
    }
    return metricsKeys;
  }
  function getOr(value, def) {
    return _.isUndefined(value) ? def : value;
  }
  function getChartMetrics(entry, metrics, metricKeys) {
    return _.transform(metrics, function (result, metric, index) {
      result[metricKeys[index]] = entry[metric];
      return result;
    }, {});
  }
  function correctLoadFactor(value) {
    return !_.isNil(value) ? value * 100 : undefined;
  }
  function correctValues(entry) {
    entry.loadFactorCurrent = correctLoadFactor(entry.loadFactorCurrent);
    entry.loadFactorExpectedFloat = entry.loadFactorExpected;
    entry.loadFactorExpected = correctLoadFactor(entry.loadFactorExpected);
    entry.loadFactorCurrentReference = correctLoadFactor(entry.loadFactorCurrentReference);
    entry.loadFactorFinalReference = correctLoadFactor(entry.loadFactorFinalReference);
    entry.availableSeatDistanceCurrent = getOr(entry.availableSeatDistanceCurrent, 0);
    entry.revenueAvailableSeatDistanceCurrent = getOr(entry.revenueAvailableSeatDistanceCurrent, 0);
    entry.revenueAvailableSeatDistanceExpected = getOr(entry.revenueAvailableSeatDistanceExpected, 0);
    entry.revenuePaxDistanceCurrent = getOr(entry.revenuePaxDistanceCurrent, 0);
    entry.revenuePaxDistanceExpected = getOr(entry.revenuePaxDistanceExpected, 0);
  }
  function calculateDaResHoldTotalExpected(loadFactorExpected, physicalCapacity) {
    return _.isNumber(loadFactorExpected) && _.isNumber(physicalCapacity) ? Math.round(loadFactorExpected * physicalCapacity) : undefined;
  }
  FlightCabinTransformer.prototype.transform = function (data, metrics, metricDescriptor) {
    var dtdCriteria = _.get(metricDescriptor, 'params.dtdCriteria');
    var selectedReference = _.get(metricDescriptor, 'params.selectedReference');
    var memorizedMomentOfDepartureDate = _.memoize(getMomentOfDay);
    var memoizedTimeAMPMOfMoment = _.memoize(getTimeAMPMOfMoment, function (moment) {
      return moment.valueOf();
    });
    var memoizedISOTimeOfMoment = _.memoize(getISOTimeOfMoment, function (moment) {
      return moment.valueOf();
    });
    var memoizedYearMonthDayOfMoment = _.memoize(getYearMonthDayOfMoment, function (moment) {
      return moment.valueOf();
    });
    var memoizedGetTimeOfMoment = _.memoize(getTimeOfMoment, function (moment) {
      return moment.valueOf();
    });
    var metricsKeys = getMetricsKeys(metrics);
    var transformData = function transformData(legCabins) {
      var result = [];
      for (var i = 0, length = legCabins.length; i < length; i++) {
        var entry = legCabins[i];
        var date = memorizedMomentOfDepartureDate(entry.flightDepartureDate, momentService.FIELD.DEPARTURE_DATE);
        var legDepartureDate = memorizedMomentOfDepartureDate(entry.legDepartureDate, momentService.FIELD.DEPARTURE_DATE);
        var flightDepartureTimeString = memoizedTimeAMPMOfMoment(date);
        var curYMD = memoizedYearMonthDayOfMoment(date);
        var isLastYear = _.isUndefined(entry.flightId);
        var numberAndDate = isLastYear ? [memoizedISOTimeOfMoment(legDepartureDate), entry.leg, 'LAST_YEAR'].join(' ') : [memoizedISOTimeOfMoment(legDepartureDate), entry.flightNumber, entry.opsSuffix].join(' ');
        var newEntry = {
          flightId: entry.flightId,
          isLastYearData: isLastYear,
          legCabinId: entry.legCabinId,
          entity: entry.entity,
          referenceCurveFlightId: entry.referenceCurveFlightId,
          flightNumber: entry.flightNumber,
          scenarioName: entry.scenarioName,
          overbookedCapacity: getOr(entry.overbookedCapacity, 0),
          lastYearCurrentCapacity: getOr(entry.lastYearCurrentCapacity, 0),
          lastYearFinalCapacity: getOr(entry.lastYearFinalCapacity, 0),
          effectiveCapacity: entry.effectiveCapacity,
          physicalCapacity: entry.physicalCapacity,
          legDistance: getOr(entry.legDistance, 0),
          daysToDeparture: entry.daysToDeparture,
          resHoldTotalDeparture: entry.resHoldTotalDeparture,
          cabinCode: entry.cabinCode,
          leg: entry.leg,
          dowGroup: entry.dowGroup,
          season: entry.season,
          seasonOverride: entry.userSeasonOverride,
          departureDateDOW: entry.departureDateDOW.substr(0, 3),
          bidPrices: entry.bidPrices,
          cabinIndex: entry.cabinIndex,
          sequence: entry.sequence,
          opsSuffix: entry.opsSuffix,
          associatedServiceClasses: entry.associatedServiceClasses,
          seatsAvailableModel: entry.seatsAvailableModel,
          flightDepartureDateMoment: date,
          flightDepartureTimeMoment: memoizedGetTimeOfMoment(date),
          legDepartureDateMoment: legDepartureDate,
          flightDepartureTime: flightDepartureTimeString,
          flightDepartureDate: curYMD,
          numberAndDate: numberAndDate,
          carrier: entry.carrier,
          lowestClassAvailable: entry.lowestClassOpen,
          profileLevel: entry.profileLevel
        };
        var pastYearReference = getLastYearUnlessReferenceYearSelected(selectedReference);
        var lastYearMetrics = metricReferenceDataService.getMetricsData(['availableSeatDistance', 'revenueAvailableSeatDistance', 'revenuePaxDistance'], entry.metrics, pastYearReference);
        var referenceMetrics = metricReferenceDataService.getMetricsData(['resHoldTotal', 'revenue', 'loadFactor'], entry.metrics, selectedReference);
        referenceMetrics.resHoldTotalDeparture = newEntry.resHoldTotalDeparture;
        referenceMetrics.daResHoldTotalExpected = calculateDaResHoldTotalExpected(referenceMetrics.loadFactorExpected, entry.physicalCapacity);
        var chartMetricEntry = getChartMetrics(referenceMetrics, metrics, metricsKeys);
        var metricValues = _.extend(referenceMetrics, lastYearMetrics);
        correctValues(metricValues);
        var mergedEntry = _.extend(newEntry, metricValues, chartMetricEntry);
        result.push(mergedEntry);
      }
      return result;
    };
    var legCabins = data.domain.legCabins || data.domain.results;
    var filteredLegCabins = dtdCriteria && dtdCriteria.length ? dtdFilteringService.filterByDtd(legCabins, dtdCriteria) : legCabins;
    return transformData(filteredLegCabins);
  };
  function getLastYearUnlessReferenceYearSelected(selectedReference) {
    return selectedReference === 'referenceYear' ? 'referenceYear' : 'lastYear';
  }
  function getMomentOfDay(date, field) {
    return momentService.of(date, field);
  }
  function getTimeAMPMOfMoment(moment) {
    return rmMomentFormat(moment, 'TIME');
  }
  function getISOTimeOfMoment(moment) {
    return rmMomentFormat(moment, 'TIME_ISO');
  }
  function getYearMonthDayOfMoment(moment) {
    return rmMomentFormat(moment, 'DATE');
  }
  function getTimeOfMoment(moment) {
    return momentService.copy(moment.clone(), momentService.TYPE.LOCAL_TIME);
  }
  return FlightCabinTransformer;
};
FlightCabinTransformerFactory.$inject = ['$filter', 'DataTransformerFactory', 'MomentService', 'DtdFilteringService', 'MetricReferenceDataService'];
module.exports = FlightCabinTransformerFactory;